/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ size: NonNullable<unknown> }} Filesize_Megabytes1Inputs */

const en_filesize_megabytes1 = /** @type {(inputs: Filesize_Megabytes1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.size} MB`)
};

/**
* | output |
* | --- |
* | "{size} MB" |
*
* @param {Filesize_Megabytes1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const filesize_megabytes1 = /** @type {((inputs: Filesize_Megabytes1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filesize_Megabytes1Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_filesize_megabytes1(inputs)
});
export { filesize_megabytes1 as "fileSize_megabytes" }